import { ElementTransformer } from "@lexical/markdown"

import { $createRawHtmlNode, $isRawHtmlNode, RawHtmlNode } from "../nodes/raw-html/node"

export const RawHtmlTransformer: ElementTransformer = {
  type: "element",
  dependencies: [RawHtmlNode],
  regExp: /<div\s+data-raw-html="true"[^>]*>[\s\S]*?<\/div>/,
  replace: (parentNode, children, match) => {
    const fullMatch = match[0]
    // Extract the inner HTML content from the div with data-raw-html="true"
    const innerHtmlMatch = fullMatch.match(/<div\s+data-raw-html="true"[^>]*>([\s\S]*?)<\/div>/)

    if (innerHtmlMatch) {
      const html = innerHtmlMatch[1]
      const rawHtmlNode = $createRawHtmlNode({ html })
      parentNode.replace(rawHtmlNode)
    }
  },
  export: (node) => {
    if (!$isRawHtmlNode(node)) {
      return null
    }
    return `<div data-raw-html="true">${node.getHtml()}</div>`
  },
}
